const VIDEO_EXTENSIONS = [".mp4", ".webm", ".mov", ".m4v", ".ogv"]

export const isVideoMedia = (media) => {
    if (!media?.url) return false
    if (media?.type === "video") return true
    const url = String(media.url).split("?")[0].toLowerCase()
    return VIDEO_EXTENSIONS.some((ext) => url.endsWith(ext))
}

export const getReviewMedia = (item) => {
    const media = Array.isArray(item?.media) ? item.media : []
    return media.filter((m) => m?.url)
}

export const buildReviewGallery = (reviews) => {
    const list = Array.isArray(reviews) ? reviews : []
    const images = []
    const offsetByReviewIndex = {}

    list.forEach((item, reviewIndex) => {
        const review = item?.review
        const media = getReviewMedia(item)

        if (media.length === 0) return

        offsetByReviewIndex[reviewIndex] = images.length

        media.forEach((entry, imageIndex) => {
            const isVideo = isVideoMedia(entry)

            images.push({
                type: isVideo ? "video" : "photo",
                thumbSrc: entry.preview_url || entry.url,
                fullSrc: entry.url,
                review,
                reviewIndex,
                imageIndex,
            })
        })
    })

    return { images, offsetByReviewIndex }
}
